import CrudManager from "./CrudManager";

const fields = [
  { key: "name", label: "Name" },
  { key: "slug", label: "Slug (URL)" },
  { key: "tagline", label: "Tagline", full: true },
  { key: "website", label: "Website URL" },
  { key: "rating", label: "Rating (0-5)", type: "number" },
  { key: "rank", label: "Rank (Best-of order)", type: "number" },
  { key: "status", label: "Status", type: "select", options: ["draft", "published"] },
  { key: "pricing_start", label: "Starting price" },
  { key: "pricing_details", label: "Pricing details", type: "textarea" },
  { key: "best_for", label: "Best for", type: "textarea" },
  { key: "features", label: "Features (power filters & matrix)", type: "tags", full: true },
  { key: "integrations", label: "Integrations", type: "tags", full: true },
  { key: "category_slugs", label: "Category slugs", type: "tags", full: true },
  { key: "pros", label: "Pros", type: "list" },
  { key: "cons", label: "Cons", type: "list" },
  { key: "verdict", label: "Bottom line verdict", type: "textarea" },
  { key: "description", label: "Full review (Markdown)", type: "markdown" },
  { key: "logo_url", label: "Logo", type: "image" },
  { key: "seo_title", label: "SEO title", full: true },
  { key: "seo_description", label: "SEO meta description", type: "textarea" },
];

export default function AdminSoftware() {
  return (
    <CrudManager
      collection="software"
      title="Software Reviews"
      singular="review"
      fields={fields}
      listColumns={[
        { key: "name", label: "Name" },
        { key: "rating", label: "Rating" },
        { key: "pricing_start", label: "Price" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
